import React from "react";
import { Stack, Typography, Button } from "@mui/material";
import { TextField } from "../inputs";
import { Link } from "../buttons";
import { useFormik } from "formik";
import * as Yup from "yup";
export interface SignupProfessionalStepFourInterface {
  handleAction: (data: any) => void;
  initialData: { label?: string; value: string }[];
  schema: any;
}
const SignupProfessionalStepFour = ({
  initialData,
  handleAction,
  schema,
}: SignupProfessionalStepFourInterface) => {
  const { values, handleSubmit, setFieldValue, errors, touched }: any =
    useFormik({
      initialValues: { interests: initialData },
      validationSchema: Yup.object().shape(schema),
      onSubmit: (value) => {
        handleAction(value);
      },
    });
  return (
    <Stack justifyContent="center" alignItems="center" spacing={5}>
      <Stack alignItems="center" spacing={3}>
        <Typography variant="h1" fontWeight={700} textAlign="center">
          Give us your top areas of Industry Interest
        </Typography>
        <Typography variant="h4" fontWeight={500} textAlign="center">
          Find out “What’s Going On” in the financial services industry right at
          your fingertips - Getting started is easy!
        </Typography>
      </Stack>
      <Typography textAlign="center" variant="h4" fontWeight={400}>
        This will help us make good recommendations for you
      </Typography>
      <Stack width="100%" spacing={1} height="240px" overflow="auto">
        {values.interests.map(
          (interest: { label?: string; value: string }, index: number) => (
            <TextField
              boldLabel
              label={`Interest ${index + 1} `}
              subLabel={interest.label ? `- ${interest.label}` : ""}
              id={`interests[${index}]`}
              name={`interests[${index}]`}
              value={interest.value}
              onChange={(e) =>
                setFieldValue(`interests[${index}].value`, e.target.value)
              }
              helperText={
                touched.interests &&
                touched.interests[index] &&
                touched.interests[index].value &&
                errors !== null
                  ? errors.interests &&
                    errors.interests[index] &&
                    errors.interests[index].value
                  : ""
              }
              error={
                touched.interests &&
                touched.interests[index] &&
                errors !== null &&
                errors.interests &&
                errors.interests[index] &&
                errors.interests[index].value
              }
            />
          )
        )}
      </Stack>
      <Stack alignSelf="flex-start">
        <Link
          fontWeight={600}
          label="+ Add More Interest"
          onClick={() =>
            setFieldValue("interests", [...values.interests, { value: "" }])
          }
        />
      </Stack>

      <Button
        variant="contained"
        type="submit"
        color="primary"
        fullWidth
        onClick={() => handleSubmit()}
      >
        Next
      </Button>
    </Stack>
  );
};
export default SignupProfessionalStepFour;
